import Reveal from "@/components/SectionReveal";

export default function ServiceOverviewBand() {
  return (
    <section className="relative bg-white/80 backdrop-blur-[2px]" data-testid="service-overview-band">
      <div className="max-w-5xl mx-auto px-6 sm:px-10 py-10 sm:py-20 text-center">
        <Reveal>
          <p className="text-[11px] sm:text-xs tracking-[0.22em] uppercase font-bold text-sky-700">
            Everywhere in Tampa Bay
          </p>
          <p className="mt-4 font-heading text-xl sm:text-2xl lg:text-[28px] leading-snug font-semibold text-slate-900">
            Weekly pool cleaning, green pool cleanup, filter &amp; pump service, and{" "}
            <span className="text-sky-700">24/7 emergency repair</span> across{" "}
            <span className="text-slate-900">Clearwater, Tarpon Springs, Trinity, Dunedin, Palm Harbor, Oldsmar, Westchase, Town &amp; Country, Odessa, and Carrollwood.</span>
          </p>
        </Reveal>
      </div>
      <div className="h-px max-w-5xl mx-auto bg-gradient-to-r from-transparent via-slate-200 to-transparent" />
    </section>
  );
}
